module.exports = __webpack_public_path__ + "img/mach.2d1dbc28.png";